import { OuiSelectOption } from 'omnium-ui/form-field';

export type NiveauEtude = 'ECO' | 'COL' | 'LYC' | 'SUP' | 'AUTRE';

export const niveauEtudeOptions: OuiSelectOption<NiveauEtude>[] = [
  { label: 'Ecole', value: 'ECO' },
  { label: 'Collège', value: 'COL' },
  { label: 'Lycée', value: 'LYC' },
  { label: 'Enseignement supérieur', value: 'SUP' },
  { label: 'Autre', value: 'AUTRE' },
];
